// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper_1vCop","card":"index_card_1-hDr","detail":"index_detail_37ntO"};